namespace appn.ajax {

    function baseAjax(appnAjaxSettings: AppnAjaxSettings, method: string) {
        if (!appnAjaxSettings.url) {
            appn.log.warning('appn.ajax called with no url.');
            return;
        }

        const $ajaxSettings: JQueryAjaxSettings = {
            headers: appn.verifyHeader,
            url: appnAjaxSettings.url,
            data: appnAjaxSettings.data,
            contentType: appnAjaxSettings.contentType === undefined ? 'application/x-www-form-urlencoded; charset=UTF-8' : appnAjaxSettings.contentType,
            type: method,
            cache: false,
            processData: appnAjaxSettings.processData === undefined ? true : appnAjaxSettings.processData
        };

        // Only set dataType if its passed in as the intelligent guess will not work 
        if (appnAjaxSettings.dataType)
            $ajaxSettings.dataType = appnAjaxSettings.dataType;

        appn.log.info(`appn.ajax ${method} STARTED`);
        appn.log.info($ajaxSettings);
        $.ajax($ajaxSettings)
            .done(function(data: any, textStatus: string, jqXHR: JQueryXHR) {
                if (appnAjaxSettings.done)
                    appnAjaxSettings.done(data, textStatus, jqXHR);
                appn.log.info(`appn.ajax ${textStatus}`);
            })
            .fail(function(jqXHR: JQueryXHR, textStatus: string, errorThrown: any) {
                if (appnAjaxSettings.fail)
                    appnAjaxSettings.fail(jqXHR, textStatus, errorThrown);
                appn.log.error(`appn.ajax ${textStatus}`);
            })
            .always(function(dataOrJqXHR: any | JQueryXHR, textStatus: string, jqXHROrErrorThrown: JQueryXHR | any) {
                if (appnAjaxSettings.always)
                    appnAjaxSettings.always(dataOrJqXHR, textStatus, jqXHROrErrorThrown);
                appn.log.info(`appn.ajax ${method} FINISHED`);
            });
    }

    export function get(appnAjaxSettings: AppnAjaxSettings) {
        baseAjax(appnAjaxSettings, 'GET');
    }

    export function post(appnAjaxSettings: AppnAjaxSettings) {
        baseAjax(appnAjaxSettings, 'POST');
    }

    interface AppnAjaxSettings {
        url: string;
        data?: JQuery.PlainObject | string | undefined;
        done?: Function;
        fail?: Function;
        always?: Function;
        dataType?: string;
        contentType?: string | false | undefined;
        processData?: boolean | undefined;
    }
}
